import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';

@Component({
  selector: 'app-credit-card-conversion-reward-calculator',
  templateUrl: './credit-card-conversion-reward-calculator.component.html',
  styleUrls: ['./credit-card-conversion-reward-calculator.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.Emulated
})
export class CreditCardConversionRewardCalculatorComponent {
  initialValue = 2500;
  sliderValue1 = 2500;
  sliderValue2 = 2500;
  sliderValue3 = 2500;
  sliderValue4 = 2500;
  result1: number;
  result2: number;
  result3: number;
  result4: number;
  result5: number;
  totalResult: number;
  maxLimit = 7000;

  @Input() contentRewards : any;
  public imagePrefix: string;
  constructor(private mktEnvironmentService: MktEnvironmentService,@Inject(DOCUMENT) private _document: Document) {
    this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
  }
  
  sliderCalculation(value,i,rate) {
    let element = ".ui-slider-tip"+i;
    let handle = "#slider"+i+" div.handle.right"
    let resultId = "result"+i;
    if(!!($(handle).position()) && ($(handle).position().left > 0))
      $(element).css('left',$(handle).position().left + 23);
    //let annualMonth = 0;
    let result = 0;
    
    this.sliderValue1=((rate==0.05)? value : this.sliderValue1);
    this.sliderValue2=((rate==0.04)? value : this.sliderValue2);
   
   /* if(rate == 0.05){
      this.cashBackCalculation(rate,i,value);
      this.cashBackCalculation(0.04,i+1,this.sliderValue2);
    }else if(rate == 0.04){
      this.cashBackCalculation(rate,i,value);
      this.cashBackCalculation(0.05,i-1,this.sliderValue1);
    }*/

    if(rate == 0.05 || rate == 0.04){
      this.cashBackCalculation();
    }

    /* if(rate == 0.04) {
      annualMonth = ((value)*12);
      if (annualMonth>7000) {
        result =  Math.floor((7000*rate) + ((annualMonth-7000)*0.01));
      } else {
        result =  Math.floor((annualMonth*rate));
      }
      this._document.getElementById(resultId).setAttribute('value','$'+result);
    } */
    else {
      result = Math.floor(value*parseFloat(rate)*12);
      this._document.getElementById(resultId).setAttribute('value','$'+result);
    }
    this.totalCalculation();
  }

   /*cashBackCalculation(rate,i,sliderValue) {
      let numberMonths = (7000/(this.sliderValue1 + this.sliderValue2));
      let valueResult=0;
      if (numberMonths < 12) {
        valueResult =  Math.floor(Math.floor(numberMonths)*rate*sliderValue + (Math.ceil(12-numberMonths)*0.01*sliderValue));
      } else {
        valueResult =  Math.floor((sliderValue*rate*12));
      }
      this._document.getElementById("result"+i).setAttribute('value','$'+valueResult);
   }*/

    cashBackCalculation() {
      let numberMonths = (this.maxLimit/(this.sliderValue1 + this.sliderValue2));
      let valueResult1=0;
      let valueResult2=0;
      let sliderResult=0;
      if (numberMonths < 12) {
        valueResult1 =  (Math.floor(numberMonths)*0.05*this.sliderValue1);
        valueResult2 =  (Math.floor(numberMonths)*0.04*this.sliderValue2);
        sliderResult = Math.floor(numberMonths)*(this.sliderValue1+ this.sliderValue2) ;
        
        if(sliderResult < this.maxLimit){ 
          if((this.maxLimit-sliderResult) >= this.sliderValue1){
            valueResult1 = Math.floor( valueResult1 + (this.sliderValue1*0.05) + (Math.floor(12-numberMonths)*0.01*this.sliderValue1));
            sliderResult = sliderResult + this.sliderValue1;
            valueResult2 = Math.floor( valueResult2 + ((this.maxLimit-sliderResult)*0.04) + ((this.sliderValue2-this.maxLimit+sliderResult)*0.01) + (Math.floor(12-numberMonths)*0.01*this.sliderValue2));
          }else{
            valueResult1 = Math.floor( valueResult1 + ((this.maxLimit-sliderResult)*0.05) + ((this.sliderValue1-this.maxLimit+sliderResult)*0.01) + (Math.floor(12-numberMonths)*0.01*this.sliderValue1));
            valueResult2 = Math.floor( valueResult2 + (Math.ceil(12-numberMonths)*0.01*this.sliderValue2));
          }
        }else{ //valueResult==7000
          valueResult1 = Math.floor( valueResult1 + (Math.floor(12-numberMonths)*0.01*this.sliderValue1));
          valueResult2 = Math.floor( valueResult2 + (Math.floor(12-numberMonths)*0.01*this.sliderValue2));
        }
      } else {
        valueResult1 = Math.floor((this.sliderValue1*0.05*12));
        valueResult2 = Math.floor((this.sliderValue2*0.04*12));
      }
      this._document.getElementById("result1").setAttribute('value','$'+valueResult1);
      this._document.getElementById("result2").setAttribute('value','$'+valueResult2);
    }  

  totalCalculation() {
    this.totalResult = 0;
    this.contentRewards.sliderContent?.forEach((item,i)=>{
      let id = i+1;
      let resultId = "result"+id;
      let value = this._document.getElementById(resultId).getAttribute('value')
      this.totalResult+= Number(value.slice(1));
    });
  }
  scrollToElement($element) {
    let element = this._document.getElementById($element);
    element.scrollIntoView(
      {
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      }
    );
  }
}

